import { Tooltip } from "antd";
import { AddIcon } from "../../shared/Icons/AddIcon";
import { Container } from "./style";

interface IProps {
  onAdd: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  tooltip?: string;
}

export const AddButton = ({ onAdd, style, disabled=false, tooltip }: IProps) => {
  return (
    <Tooltip title={tooltip} placement="bottom">
      <Container disabled={disabled} style={style} onClick={disabled ? undefined : onAdd}>
        <AddIcon />
      </Container>
    </Tooltip>
  );
}